export default function SignUp(){
    return <div>
        <p>Login</p>
    </div>
}